import { render, staticRenderFns } from "./TechnicalData.vue?vue&type=template&id=c8dad3ea&scoped=true&"
import script from "./TechnicalData.vue?vue&type=script&lang=js&"
export * from "./TechnicalData.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalData.vue?vue&type=style&index=0&id=c8dad3ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dad3ea",
  null
  
)

export default component.exports